import { useState } from "react";
import { KeyRound, LogOut } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

export function Section({ icon: Icon, title, children }) {
  return (
    <section className="rounded-xl border border-[#1E2638] bg-[#0F141C] p-6">
      <h2 className="mb-4 flex items-center gap-2 font-head text-base font-bold">
        <Icon className="h-5 w-5 text-primary" /> {title}
      </h2>
      {children}
    </section>
  );
}

export const apiError = (err, fallback = "Échec") => formatApiErrorDetail(err.response?.data?.detail) || fallback;

export function PasswordSection() {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Mot de passe modifié. Vos autres appareils ont été déconnectés.");
      setCur("");
      setNw("");
    } catch (err) {
      toast.error(apiError(err));
    }
    setBusy(false);
  };

  return (
    <Section icon={KeyRound} title="Changer le mot de passe">
      <form onSubmit={submit} className="space-y-4">
        <div className="space-y-1.5">
          <Label>Mot de passe actuel</Label>
          <Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} required data-testid="account-current-password" />
        </div>
        <div className="space-y-1.5">
          <Label>Nouveau mot de passe</Label>
          <Input type="password" value={nw} onChange={(e) => setNw(e.target.value)} required data-testid="account-new-password" />
        </div>
        <Button type="submit" disabled={busy} data-testid="account-change-password-button">{busy ? "…" : "Mettre à jour"}</Button>
      </form>
    </Section>
  );
}

export function SessionsSection({ onLoggedOut }) {
  const logoutAll = async () => {
    try {
      await api.post("/auth/logout-all");
      toast.success("Tous les appareils ont été déconnectés.");
      onLoggedOut();
    } catch (err) {
      toast.error(apiError(err));
    }
  };
  return (
    <Section icon={LogOut} title="Sessions">
      <p className="mb-4 text-sm text-muted-foreground">
        Une session dure 24 h. Changer de mot de passe ou désactiver la MFA déconnecte automatiquement vos autres appareils.
      </p>
      <Button variant="outline" onClick={logoutAll} data-testid="account-logout-all-button" className="gap-1.5">
        <LogOut className="h-4 w-4" /> Déconnecter tous les appareils
      </Button>
    </Section>
  );
}
